"use strict";
/* eslint-disable @typescript-eslint/use-unknown-in-catch-callback-variable */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import('./bootstrap').catch((err) => console.error('error main:', err));
//# sourceMappingURL=main.js.map